export default "__VITE_ASSET__oIPfZtrx__"